import AxiosInstance from 'src/shared/services/axios/interceptor';

export interface ImagePost {
  file: File;
}

const controller = 'Image';

const createFormData = (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  return formData;
};

export const createImage = (data: File) => {
  const endpoint = `${controller}`;
  const formData = createFormData(data);
  return AxiosInstance.post(endpoint, formData);
};

// TODO: Typa
export const getImageByGuid = (guid: string) => {
  const endpoint = `${controller}/data/${guid}`;
  return AxiosInstance.get<any>(endpoint);
};
